import { observer } from 'mobx-react';
import { FC, ReactElement, memo } from 'react';
import { mealItemEditModalStore } from '../../store/mealItemEditModalStore';
import integrationsStore from '~/mobx/integrationStore';
import { isDisabledByPos } from '~/utils/helpers';
import { TOOLTIP_DURATION, TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import { ProductWarning } from '~/view/components/ProductWarning';
import Text from '~/view/components/Text/Text';

export const MealItemEditModalFormHeader: FC = memo(
  observer((): ReactElement => {
    const { comboMealChangeItemInItemChoice } = integrationsStore.posRestrictions || {};

    return (
      <div className="d-flex flex-row">
        <Text
          type="block-header"
          text="item"
          disabled={isDisabledByPos(comboMealChangeItemInItemChoice)}
          required
          tooltip={{
            message: 'mc_nosize_nomodifier',
            duration: TOOLTIP_DURATION.EXTRA_LARGE,
            position: TOOLTIP_POSITION.PORTAL,
            minWidth: 370,
            iconSize: 16,
          }}
        />

        <ProductWarning
          type="mealItemsInEditPage"
          comboItem={mealItemEditModalStore.item}
          iconSize={18}
          marginLeft={2}
          position={TOOLTIP_POSITION.PORTAL}
        />
      </div>
    );
  })
);
